import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "825cd201-1cfb-4f83-bb66-44af67b7bd03",
    content: "The effect of a sound on a soundscape can be<br>explained via acoustic properties only.",
    options: {},
  },
  {
    id: "d6541bfd-8c8b-4b32-8f88-1cf155adb4a5",
    content: "Evaluating a soundscape is best done<br>via sound pressure levels only.",
    options: {},
  },
  {
    id: "db0478d2-b7a1-4a22-931f-2b5d19fd72e9",
    content: "Adding sounds to a soundscape will always<br>have a negative impact on the soundscape.",
    options: {},
  },
  {
    id: "8488675e-d17c-4666-80eb-98da14d3a4aa",
    content: "The main tool for soundscape<br>evaluation is jury testing.",
    options: {},
  },
  {
    id: "75f09e5d-bbe1-4c8a-bf0e-502654afda64",
    content: "When evaluation a soundscape sound,<br>context and the listener are relevant.",
    options: {},
  },
  {
    id: "de7230f0-85b1-4347-94f6-5dc5a45e7681",
    content: "When evaluating a soundscape<br>binaural hearing should be used.",
    options: {},
  },
];

export const task: Task = {
  id: "912a80ac-fed2-4d79-a2b8-df159cb7efe1",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "8488675e-d17c-4666-80eb-98da14d3a4aa",
    "75f09e5d-bbe1-4c8a-bf0e-502654afda64",
    "de7230f0-85b1-4347-94f6-5dc5a45e7681",
  ],
};
